import React from 'react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <a {...props} className={`
        inline-flex items-center justify-center px-8 py-4 
        bg-gold-500 text-white font-serif font-semibold text-lg md:text-xl
        rounded-sm shadow-md hover:bg-gold-600 hover:shadow-lg
        transition-all duration-300 ease-out transform hover:-translate-y-1
        text-center tracking-wide
        ${className}
      `} data-id="element-13">
      {children}
    </a>;
}